<template>
  <div class="panel-group" :style="formType === 'process' ? 'padding-right: 40px; width: 100%' : 'width:100%'">
    <div class="d-flex" :class="{
      'col-6': formType === 'process',
      'col-4': formType !== 'process' && formType !== 'fileAccess',
      'col-5': formType === 'fileAccess'
    }" style="height: min-content">
      <label class="form-label ">{{ label }} <Tooltip v-if="showInfo" :text="tooltip || label"><i
            class="ag-icon ag-icon_table_info small info-icon" /></Tooltip> </label>
    </div>
    <div :class="{
      'err-msg': isInvalid,
      'col-6': formType === 'process',
      'col-8': formType !== 'process' && formType !== 'fileAccess',
      'col-7': formType === 'fileAccess'
    }" :style="formType === 'process' ? 'padding-left: 0' : ''">
      <InputText v-if="label !== 'Description'" v-model="internalValue" :placeholder="placeholder" class="base-input" :maxlength="maxLength"
        :aria-describedby="isInvalid ? `error-message-${label}` : null" :style="{
          width: formType === 'fileTypePolicy' ? '100%' :
            formType === 'process' ? '70%' :
              'inherit'
        }" :disabled="disabled" />
        <textarea v-else class="notes-textarea" :placeholder="placeholder" maxlength="1001" rows="4"
        v-model="internalValue" :disabled="disabled" />
      <small v-if="isInvalid" :id="`error-message-${label}`" class="p-error">{{ errorMessage }}</small>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue'
import InputText from 'primevue/inputtext'
import Tooltip from './tooltip.vue'

const props = defineProps({
  modelValue: String,
  label: String,
  placeholder: String,
  showInfo: {
    type: Boolean,
    default: true
  },
  maxLength: {
    type: Number,
    default: null
  },
  errorMessage: {
    type: String,
    default: ''
  },
  isInvalid: {
    type: Boolean,
    default: false
  },
  formType: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false
  },
  tooltip: {
    type: String,
    default: ''
  }
})
const emit = defineEmits(['update:modelValue'])
const internalValue = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})
</script>

<style scoped>
.panel-group {
  display: flex;
  font-size: 0.8rem !important;
}


.form-label {
  font-weight: bold;
  color: #164b6c;
  display: inline-flex;
}

.info-icon {
  color: #6c757d;
  margin-left: 6px;
  display: inline-flex;
  align-items: center;
}

.base-input {
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
}

.err-msg {
  display: grid;
}

.p-error {
  color: #ef4444;
  margin-top: 0.25rem;
}

::v-deep .p-tooltip {
  z-index: 2147483647 !important;
}

.notes-textarea {
    width: inherit;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 8px;
    font-size: 0.85rem;
    resize: vertical;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 transparent;
}

.notes-textarea:focus,
.notes-textarea:focus-visible {
    outline: none;
    box-shadow: none;
    border-color: #cbd5e1;
}

.notes-textarea::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}
.notes-textarea::-webkit-scrollbar-track {
    background: transparent;
}
.notes-textarea::-webkit-scrollbar-thumb {
    background-color: #cbd5e1; 
    border-radius: 8px;
    border: 2px solid transparent;
    background-clip: content-box;
}
.notes-textarea::-webkit-scrollbar-thumb:hover {
    background-color: #94a3b8;
}
</style>
